import { QuoteRequestCartItem, CartItemType } from '@sbd-doug-frontend/shared/lib/shopping-cart/shopping-cart.types';
import { OpenQuoteRequestsItem } from '../modules/dashboard/open-quote-requests-widget/quote-requests.types';

export function createShoppingCartItem(item: OpenQuoteRequestsItem): QuoteRequestCartItem<OpenQuoteRequestsItem> {
  // Create reactive shopping cart item that updates when selected quote changes
  const cartItem: QuoteRequestCartItem<OpenQuoteRequestsItem> = {
    type: CartItemType.QUOTE_REQUEST,
    id: item.quote_request_id.toString(),
    display_name: item.order_number,
    data: item,
    quantity: 1,
    // Static properties for initial display (will be overridden by reactive methods)
    price: item.selected_quote?.premium || 0,
    tax: 0, // TODO: Calculate tax if needed
    shipping: item.shipping_option_price || 0,
    showQuantity: false,

    // Reactive methods that read current selected quote
    getTotal() {
      return cartItem.data.selected_quote?.premium || 0;
    },
    getTax() {
      return 0; // TODO: Calculate tax if needed
    },
    getShipping() {
      return cartItem.shipping || cartItem.data.shipping_option_price || 0;
    },
    getSubtotal() {
      return cartItem.data.selected_quote?.premium || 0;
    },
    getTotalWithTax() {
      const premium = cartItem.data.selected_quote?.premium || 0;
      const tax = 0; // TODO: Calculate tax if needed
      return premium + tax;
    },
    getTotalWithShipping() {
      const premium = cartItem.data.selected_quote?.premium || 0;
      const shipping = cartItem.shipping || cartItem.data.shipping_option_price || 0;
      return premium + shipping;
    },
    getTotalWithTaxAndShipping() {
      const premium = cartItem.data.selected_quote?.premium || 0;
      const tax = 0; // TODO: Calculate tax if needed
      const shipping = cartItem.shipping || cartItem.data.shipping_option_price || 0;
      return premium + tax + shipping;
    },
  };

  return cartItem;
}
